import {i18n} from 'src/i18n';
import authSelectors from 'src/modules/auth/authSelectors';
import FirmaService from 'src/modules/firma/firmaService';
import exporterFields from 'src/modules/firma/list/firmaListExporterFields';
import selectors from 'src/modules/firma/list/firmaListSelectors';
import Errors from 'src/modules/shared/error/errors';
import Exporter from 'src/modules/shared/exporter/exporter';
import {canUsePartialVerification} from 'src/security/partialVerificationAccess';

const prefix = 'FIRMA_LIST';

const firmaListActions = {
  FETCH_STARTED: `${prefix}_FETCH_STARTED`,
  FETCH_SUCCESS: `${prefix}_FETCH_SUCCESS`,
  FETCH_ERROR: `${prefix}_FETCH_ERROR`,

  RESETED: `${prefix}_RESETED`,
  TOGGLE_ONE_SELECTED: `${prefix}_TOGGLE_ONE_SELECTED`,
  TOGGLE_ALL_SELECTED: `${prefix}_TOGGLE_ALL_SELECTED`,
  CLEAR_ALL_SELECTED: `${prefix}_CLEAR_ALL_SELECTED`,

  PAGINATION_CHANGED: `${prefix}_PAGINATION_CHANGED`,
  SORTER_CHANGED: `${prefix}_SORTER_CHANGED`,

  EXPORT_STARTED: `${prefix}_EXPORT_STARTED`,
  EXPORT_SUCCESS: `${prefix}_EXPORT_SUCCESS`,
  EXPORT_ERROR: `${prefix}_EXPORT_ERROR`,

  PATCH_ONE: `${prefix}_PATCH_ONE`,

  doClearAllSelected() {
    return {
      type: firmaListActions.CLEAR_ALL_SELECTED,
    };
  },

  doToggleAllSelected() {
    return {
      type: firmaListActions.TOGGLE_ALL_SELECTED,
    };
  },

  doToggleOneSelected(id) {
    return {
      type: firmaListActions.TOGGLE_ONE_SELECTED,
      payload: id,
    };
  },

  doReset: () => async (dispatch) => {
    dispatch({
      type: firmaListActions.RESETED,
    });

    dispatch(firmaListActions.doFetch());
  },

  doExport: () => async (dispatch, getState) => {
    try {
      if (!exporterFields || !exporterFields.length) {
        throw new Error('exporterFields is required');
      }

      dispatch({
        type: firmaListActions.EXPORT_STARTED,
      });

      const filter = selectors.selectFilter(getState());
      const response = await FirmaService.list(filter, selectors.selectOrderBy(getState()), null, null);
      const currentTenant = authSelectors.selectCurrentTenant(getState());
      const partialVerificationEnabled = canUsePartialVerification(currentTenant?.id);
      const exportFields = partialVerificationEnabled
        ? exporterFields
        : exporterFields.filter((field) => field.name !== 'tipoFirma');
      const exportRows = partialVerificationEnabled
        ? response.rows
        : response.rows.filter((row) => row.tipoFirma !== 'parcial');

      new Exporter(exportFields, i18n('entities.firma.exporterFileName')).transformAndExportAsExcelFile(exportRows);

      dispatch({
        type: firmaListActions.EXPORT_SUCCESS,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: firmaListActions.EXPORT_ERROR,
      });
    }
  },

  doChangePagination: (pagination) => async (dispatch, getState) => {
    dispatch({
      type: firmaListActions.PAGINATION_CHANGED,
      payload: pagination,
    });

    dispatch(firmaListActions.doFetchCurrentFilter());
  },

  doChangeSort: (sorter) => async (dispatch, getState) => {
    dispatch({
      type: firmaListActions.SORTER_CHANGED,
      payload: sorter,
    });

    dispatch(firmaListActions.doFetchCurrentFilter());
  },

  doFetchCurrentFilter: () => async (dispatch, getState) => {
    const filter = selectors.selectFilter(getState());
    const rawFilter = selectors.selectRawFilter(getState());
    dispatch(firmaListActions.doFetch(filter, rawFilter, true));
  },

  doFetch:
    (filter?, rawFilter?, keepPagination = false) =>
    async (dispatch, getState) => {
      try {
        dispatch({
          type: firmaListActions.FETCH_STARTED,
          payload: {filter, rawFilter, keepPagination},
        });

        const response = await FirmaService.list(
          filter,
          selectors.selectOrderBy(getState()),
          selectors.selectLimit(getState()),
          selectors.selectOffset(getState()),
        );

        dispatch({
          type: firmaListActions.FETCH_SUCCESS,
          payload: {
            rows: response.rows,
            count: response.count,
          },
        });
      } catch (error) {
        Errors.handle(error);

        dispatch({
          type: firmaListActions.FETCH_ERROR,
        });
      }
    },
};

export default firmaListActions;
